import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { useDocumentMeta } from "../hooks/use-document-meta";
import GUIDE_CONTENT from "./guideContent";
import "./UserGuide.css";

const IMG = "/static/guide";

// Each section's screenshot(s) — shared across all languages (the app UI
// itself, not the guide text, is what a screenshot shows). The Telugu
// dashboard shot doubles as the illustration for how language-switching
// looks, regardless of which language the guide is currently in.
const SECTION_IMAGES = {
  dashboard: [{ src: `${IMG}/01-dashboard.jpg`, alt: "Dashboard" }],
  full: [{ src: `${IMG}/02-full-panchangam.jpg`, alt: "Get Panchangam" }],
  festival: [
    { src: `${IMG}/03-festival-picker.png`, alt: "Festival picker with search" },
    { src: `${IMG}/03b-festival-search-result.png`, alt: "Searching in English finds a festival while the app is in another language" },
  ],
  location: [
    { src: `${IMG}/04-location-picker.png`, alt: "Location picker" },
    { src: `${IMG}/05-language-menu.png`, alt: "Language menu" },
    { src: `${IMG}/05b-dashboard-telugu.jpg`, alt: "Dashboard in Telugu" },
  ],
  muhurtam: [
    { src: `${IMG}/06-muhurtam-disclaimer.png`, alt: "Muhurtam disclaimer" },
    { src: `${IMG}/07-muhurtam-form.png`, alt: "Muhurtam form" },
    { src: `${IMG}/07b-muhurtam-kundalini-section.png`, alt: "Personal Kundalini chart section" },
    { src: `${IMG}/07c-muhurtam-kundalini-chart.png`, alt: "Personal Kundalini chart rendered" },
    { src: `${IMG}/08-muhurtam-results.png`, alt: "Muhurtam results" },
    { src: `${IMG}/08b-muhurtam-slot-chart.png`, alt: "Kundalini chart opened from a safe-time slot" },
  ],
};

const SECTION_ORDER = ["calendar", "dashboard", "full", "festival", "location", "muhurtam"];

export default function UserGuide() {
  useDocumentMeta(
    "User Guide — Yagnika Panchangam",
    "How to use Yagnika Panchangam: reading your daily tithi and nakshatra, checking Muhurtam timings, and setting your location."
  );
  const { lang } = useLanguage();
  const content = GUIDE_CONTENT[lang] || GUIDE_CONTENT.en;

  return (
    <div className="guide-page">
      <div className="guide-container">
        <Link to="/" className="guide-back-link">{content.backLink}</Link>
        <img src="/static/Logo.webp" alt="Yagnika" className="guide-logo" />
        <h1 className="guide-title">{content.title}</h1>
        <p className="guide-subtitle">{content.subtitle}</p>

        {SECTION_ORDER.map((key) => {
          const sec = content.sections[key];
          if (!sec) return null;
          const images = SECTION_IMAGES[key];
          return (
            <section key={key} className={`guide-section ${key === "calendar" ? "guide-highlight" : ""}`}>
              <h2>{sec.heading}</h2>
              <p>{sec.body}</p>
              {images && (
                <div className="guide-shots">
                  {images.map((img) => (
                    <img key={img.src} src={img.src} alt={img.alt} className="guide-shot" loading="lazy" />
                  ))}
                </div>
              )}
            </section>
          );
        })}

        <Link to="/" className="guide-back-link guide-back-link-bottom">{content.backLink}</Link>
      </div>
    </div>
  );
}
